export default "__VITE_ASSET__fUcVHXv7__"